import { ComponentBase } from "../../_ComponentBase";

/**
 * Base component for mass data loading.
 */
export abstract class DataImportComponentBase extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = { };

    /** No controller */
    public controller = null;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/helpers/import/DataImport.html";
}
